import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-body font-medium transition-all duration-300 ease-out rounded-sm';
  const variants = {
    primary: 'bg-terracotta text-white hover:bg-terracotta-dark shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    secondary: 'bg-gold text-white hover:bg-gold-dark shadow-md hover:shadow-lg',
    outline: 'border border-gold text-gold hover:bg-gold/10'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-8 py-3 text-base',
    lg: 'px-10 py-4 text-lg tracking-wide'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} className={combinedClassName} data-id="element-255">
        {children}
      </a>;
  }
  return <button className={combinedClassName} {...props} data-id="element-256">
      {children}
    </button>;
}